import React from "react";
import { useTranslation } from "react-i18next";

interface PaymentBreakdownProps {
  groupMemberPaidAmount?: number;
  leadBookerPaidAmount?: number;
  currency: string;
  countryCode: string;
  formatCurrency: (amount: number, currency: string, countryCode: string) => string;
}

const PaymentBreakdown: React.FC<PaymentBreakdownProps> = ({
  groupMemberPaidAmount = 0,
  leadBookerPaidAmount = 0,
  currency,
  countryCode,
  formatCurrency,
}) => {
  const { t } = useTranslation();
  return (
    <div className="payment-breakdown gcw:mb-bs-3">
      <div className="gcw:p-bs-3 gcw:py-2">
        <h6 className="gcw:font-bold gcw:text-subtitle gcw:text-text-primary gcw:mb-4">
          {t("payment_breakdown_title", "Payment Breakdown")}
        </h6>
        <div className="container-payment-breakdown">
          <div className="gcw:flex gcw:justify-between gcw:items-center gcw:mb-1">
            <span className="gcw:text-order-details gcw:text-text-primary">
              {t("group_members_paid", "Group Members Paid:")}
            </span>
            <span className="gcw:text-order-details gcw:text-text-primary">
              {formatCurrency(groupMemberPaidAmount, currency, countryCode)}
            </span>
          </div>
          <div className="gcw:flex gcw:justify-between gcw:items-center">
            <span className="gcw:text-order-details gcw:text-text-primary">
              {t("lead_booker_paid", "Lead Booker Paid:")}
            </span>
            <span className="gcw:text-order-details gcw:text-text-primary">
              {formatCurrency(leadBookerPaidAmount, currency, countryCode)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentBreakdown;
